<template>
  <div class="user-list">
    <user-list-item @openUser="openUser" v-for="user in users" :key="user.id" :user="user"/>
  </div>
</template>

<script>
import UserListItem from "./UserListItem"
export default {
  name: "UserList",
  props: {
    users: {},
  },
  data: () => {
    return {

    }
  },
  components: { UserListItem },
  computed: {

  },
  methods: {
    openUser (user) {
      this.$emit('openUser', user)
    }
  }
}
</script>

<style scoped lang="scss">
  .user-list {

    /deep/ .user-list-item:nth-child(odd) {

        background: #F6F8F9;

    }

  }
</style>
